import {combineReducers} from 'redux';

import loader from './loader';
import headerFooter from './headerfooter';
import searchInfo from './searchInfo';
import searchResults from './searchResults';
import screenName from './screenName';
import cart from './cart';
import order from './order';
import customer from'./customer';
import message from './message';

export default combineReducers({
    loader,
    headerFooter,
    searchInfo,
    searchResults,
    screenName,
    cart,
    order,
    customer,
    message
});
